import moment from 'moment';
import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Session, Trip } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { RootState } from 'store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faCircle, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { BarcodeScanner, DetectedBarcode, useTorch } from 'react-barcode-scanner'
import 'react-barcode-scanner/polyfill'
import toast, { Toaster } from 'react-hot-toast';
import swal from 'sweetalert';

export const Loading = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [trips, setTrips] = useState<any[]>([]);
    const [trip, setTrip] = useState<Trip>();
    const [tripId, setTripId] = useState<number>(0);
    const [totalPackages, setTotalPackages] = useState<number>(0);
    const [scannedPackages, setScannedPackages] = useState<number>(0);
    const [packageNumbers, setPackageNumbers] = useState<any[]>([]);
    const [orderId, setOrderId] = useState<number>(0);
    const [packageNumber, setPackageNumber] = useState<string>('');
    const [screen, setScreen] = useState<string>('selectTrip');
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isTripLoading, setIsTripLoading] = useState<boolean>(false);
    const [showVehicleDetails, setShowVehicleDetails] = useState<boolean>(true);
    const paymentAmountRef = useRef<null | HTMLInputElement>(null);
    const barcodeRefRef = useRef<null | HTMLInputElement>(null);
    const audioRef = useRef<HTMLAudioElement>(null);
    const [vehicleNumber, setVehicleNumber] = useState<string>('');
    const [driverName, setDriverName] = useState<string>('');
    const [driverNumber, setDriverNumber] = useState<string>('');
    const [showFullScreenError, setShowFullScreenError] = useState<boolean>(false);
    const [fullScreenErrorMessage, setFullScreenErrorMessage] = useState<string>('');

    const showErrorModal = (message: string) => {
        setFullScreenErrorMessage(message);
        setShowFullScreenError(true);
    }

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    useEffect(() => {
        if (session) {
            loadTrips();
        }
    }, [session]);

    useEffect(() => {
        if (tripId > 0) {
            loadTrip(tripId);
        }
    }, [tripId]);

    const loadTrips = () => {
        setIsLoading(true);
        setScreen('selectTrip');
        // trip status 3 = Assigned
        ArthaGateway
            .getTrips("9", 3)
            .then((data) => {
                setTrips(data.entries);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const selectTrip = (trip) => {
        setTripId(trip.id);
        setVehicleNumber(trip.vehicleNumber);
        setDriverName(trip.driverName);
        setDriverNumber(trip.driverNumber);
        setShowVehicleDetails(true);
        setScreen('selectOrder');
    }

    const handleUnblockTrip = (trip) => {
        swal({
            title: "Unblock Trip",
            text: `Enter admin PIN to unblock trip ${trip.voucherNumber}`,
            icon: "warning",
            dangerMode: true,
            content: {
                element: "input",
                attributes: {
                    placeholder: "Admin PIN",
                    type: "password",
                },
            },
            buttons: ['Cancel', 'Unblock'],
        })
            .then((value) => {
                if (!value) return;

                const adminPIN = value.toString().trim();
                if (!adminPIN.length) {
                    toast.error('Admin PIN is required');
                    return;
                }

                setIsLoading(true);
                ArthaGateway
                    .unblockTrip(trip.id, adminPIN)
                    .then((data) => {
                        if (data?.isSuccess) {
                            toast.success(data.message || 'Trip unblocked successfully');
                            loadTrips();
                        }
                        else {
                            setIsLoading(false);
                            toast.error(data?.message || 'Unable to unblock trip');
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        setIsLoading(false);
                        toast.error('Error unblocking trip');
                    });
            });
    }

    const handleTripAction = (trip) => {
        if (trip.isBlocked) {
            toast.error(trip.blockReason || 'Trip is blocked. Please click Unblock.');
            return;
        }
        selectTrip(trip);
    }

    const loadTrip = (tripId) => {
        setIsTripLoading(true);
        ArthaGateway
            .getTrip(tripId)
            .then((data) => {
                let totalPackages = 0;
                let totalScannedPackages = 0
                data.details = data.details.reverse();
                data.details.forEach((detail, index) => {
                    if (index == 0) {
                        setOrderId(detail.order.id);
                    }
                    detail.scannedPackages = 0;
                    detail.totalPackages = detail.order.totalPackages;
                    detail.products = [];
                    detail.packages = detail.packages.filter((pack) => pack.status != "Cancelled");
                    detail.packages.reverse();

                    detail.packages.map((pack) => {
                        pack.items.map((item) => {
                            let product = detail.products.find((p) => p.productName === item.product.name);
                            if (!product) {
                                product = {
                                    productName: item.product.name,
                                    aliasName: item.product.aliasName,
                                    quantity: item.quantity,
                                    itemsPerPackage: item.product.itemsPerPackage,
                                    packages: []
                                };
                                detail.products.push(product);
                            }

                            product.packages.push({
                                packageId: pack.id,
                                packageNumber: pack.voucherNumber,
                                isScanned: (pack.status === "Loaded" || pack.status === "Delivered"),
                                numberOfProducts: item.quantity
                            });

                            if (pack.status === "Loaded" || pack.status === "Delivered") {
                                detail.scannedPackages++;
                                totalScannedPackages++;
                            }
                        });
                    });
                    totalPackages += detail.order.totalPackages;

                    console.log(detail.products);
                });

                setScannedPackages(totalScannedPackages);
                setTotalPackages(totalPackages);

                setTrip(data);
                setIsTripLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const toggleExapnd = (target) => {
        if (!trip) return;
        trip?.details.map((request) => {
            if (request.id === target.id) {
                request.isExpanded = !request.isExpanded;
            }
            else {
                request.isExpanded = false;
            }
        });
        setTrip({ ...trip });
    }

    const completeLoading = () => {
        if (!trip) return;

        swal({
            title: "Are you sure?",
            text: "Are you sure you want to mark trip as loaded?",
            icon: "warning",
            dangerMode: true,
            buttons: [
                'No, I am not sure',
                'Yes, I am sure!'
            ],
        })
            .then((isConfirmed) => {
                if (isConfirmed) {
                    ArthaGateway
                        .markTripAsLoaded(trip.id)
                        .then((data) => {
                            setTripId(0);
                            loadTrips();
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
    }

    const onBarcodeCaptured = (barcodes: DetectedBarcode[]) => {
        if (!trip) return;
        if (screen === 'scanBarcode') {
            setScreen('selectOrder');
        }

        setTimeout(() => {
            barcodes.map((barcode) => {
                handlePackageNumber(barcode.rawValue.trim());
            });
        }, 500);
    }

    const playAudio = (textToPlay) => {
        const speechSynth = window.speechSynthesis;
        if (textToPlay.trim().length) {
            let voices = speechSynthesis.getVoices();
            let indianVoice = voices.find((voice) => voice.lang === 'kn-IN');
            if (!indianVoice) {
                indianVoice = voices.find((voice) => voice.lang === 'hi-IN');
            }
            const newUtter =
                new SpeechSynthesisUtterance(textToPlay);
            if (indianVoice) {
                newUtter.voice = indianVoice;
                newUtter.lang = 'hi-IN';
            }
            speechSynth.speak(newUtter);
        }
    }

    const handlePackageNumber = (packageNumber) => {
        packageNumber = packageNumber.replace(/^0+/, '');
        let scanned = false;
        trip?.details.map((detail, index) => {
            if (detail.order.id !== orderId) return;

            detail.products.map((product) => {
                product.packages.map((pack) => {
                    if (pack.packageNumber === packageNumber) {
                        scanned = true;
                        ArthaGateway.markPackageAsLoaded(trip.id, pack.packageId)
                            .then((data) => {
                                if (data.isSuccess) {
                                    markPackageAsLoaded(pack, product, trip, detail, index);
                                }
                                else {
                                    let message = data.message || 'Error marking package as loaded';
                                    let audioToPlay = "";
                                    if (!product.aliasName || product.aliasName.trim().length === 0) {
                                        audioToPlay += product.productName;
                                    } else {
                                        audioToPlay += product.aliasName;
                                    }
                                    audioToPlay = audioToPlay + ", " + message;
                                    playAudio(audioToPlay);

                                    setTripId(0);
                                    loadTrips();

                                    showErrorModal(message);
                                }
                            });
                    }
                });
            });
        });

        if (!scanned) {
            // If package does not belong to the current trip, then check ifpackage is destroyed or not.
            let tripId: number = 0;
            if(trip) { tripId = trip.id; }
            ArthaGateway.checkIfPackageDestroyed(tripId, packageNumber)
                .then((data) => {
                    if (data.isSuccess) {
                        setPackageNumber('');
                        toast.error('Invalid package scanned');
                        audioRef?.current?.play();
                    }
                    else {
                        let message = data.message || 'Invalid package scanned';
                        playAudio(message);

                        setTripId(0);
                        loadTrips();

                        showErrorModal(message);
                    }
                });
        }
        else {
            setPackageNumber('');
        }
    }

    const markPackageAsLoaded = (pack: any, product: any, trip: any, detail: any, index: number) => {
        pack.isScanned = true;
        toast.success('Package scanned successfully');
        setPackageNumbers([...packageNumbers, packageNumber]);

        detail.scannedPackages++;
        setScannedPackages(scannedPackages + 1);
        if (detail.scannedPackages === detail.order.totalPackages) {
            toast.success('Order scanned successfully');
            if (trip.details.length > index + 1) {
                setOrderId(trip.details[index + 1].order.id);
            }
        }
        const element: any = document.getElementById("p_" + pack.packageNumber);
        if (element == null || element == undefined) {
            console.log("Element not found");
            alert("p_" + packageNumber);
            return;
        }
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - 150;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });

        if (barcodeRefRef && barcodeRefRef.current) {
            barcodeRefRef.current.focus();
        }

        element.className = 'card col-3 col-md-1 mb-1 p-0 blinking-text';
        setInterval(() => {
            element.className = 'card col-3 col-md-1 mb-1 p-0';
        }, 4000);

        let audioToPlay = (!product.aliasName || product.aliasName.trim().length === 0) ? product.productName : product.aliasName;
        if (pack.numberOfProducts < product.itemsPerPackage) {
            audioToPlay = "Partial package, " + pack.numberOfProducts.toString() + " peice of" + audioToPlay;
        }

        playAudio(audioToPlay);
        console.log("Package marked as loaded");
    }

    const handlePackage = () => {
        if (!trip) return;
        handlePackageNumber(packageNumber);
    }

    const saveVehicleDetails = () => {
        if (!trip) return;
        let vehicleData = {
            tripId: trip.id,
            vehicleNumber: vehicleNumber,
            driverName: driverName,
            driverNumber: driverNumber
        };
        ArthaGateway.updateVehicleDetails(vehicleData)
            .then((data) => {
                toast.success('Vehicle details saved successfully');
                setShowVehicleDetails(false);
                setTrip({ ...trip, vehicleNumber: vehicleNumber, driverName: driverName, driverNumber: driverNumber });
            })
            .catch(error => {
                console.log(error);
                toast.error('Error saving vehicle details');
            });
    }

    const cancelVehicleDetailsEdit = () => {
        setShowVehicleDetails(false);
        setVehicleNumber(trip?.vehicleNumber || '');
        setDriverName(trip?.driverName || '');
        setDriverNumber(trip?.driverNumber || '');
    }

    const convertKgToTon = (kilograms) => {
        if (typeof kilograms !== 'number' || isNaN(kilograms)) {
            return 'Invalid input';
        }

        // 1 ton = 1000 kg
        const tons = kilograms / 1000;

        // Use .toFixed(2) to format the number to exactly two decimal places.
        // This method returns a string representation.
        return tons.toFixed(2);
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page page-accounts'>
            <div><Toaster /></div>
            {showFullScreenError &&
                <div
                    role="alertdialog"
                    aria-modal="true"
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{ zIndex: 5000, backgroundColor: 'rgba(0, 0, 0, 0.92)', padding: '2rem' }}
                >
                    <div className="text-center text-white" style={{ maxWidth: '1000px' }}>
                        <div style={{ fontSize: 'clamp(2rem, 8vw, 5rem)', fontWeight: 800, lineHeight: 1.2 }}>
                            {fullScreenErrorMessage}
                        </div>
                        <div className="btn btn-lg btn-light mt-4" onClick={() => setShowFullScreenError(false)}>
                            Dismiss
                        </div>
                    </div>
                </div>
            }
            <audio id="alarm_sound" ref={audioRef} src="alarm.mp3" preload="auto"></audio>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    {screen === 'selectTrip' &&
                        <>
                            <h1>Select Trip</h1>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <ul className="list-group">
                                        {(!trips || trips.length == 0) &&
                                            <li className="list-group-item"><div className='alert alert-danger w-100'>No trips are assigned to any order, Please refresh again once trips are assigned</div></li>
                                        }
                                        {trips && trips.map((trip) => (
                                            <li
                                                className={trip.isBlocked ? "list-group-item align-items-center list-group-item-danger border border-danger" : "list-group-item align-items-center"}
                                                key={trip.id}
                                                onClick={() => handleTripAction(trip)}
                                            >
                                                <div className="float-start">
                                                    <div className="fw-bold">{trip.name}</div>
                                                    <div>No: {trip.voucherNumber}</div>
                                                    <div>Weight: <b>{convertKgToTon(trip.totalWeight)}</b> ton</div>
                                                    {trip.isBlocked &&
                                                        <div className="text-danger fw-bold">BLOCKED {trip.blockReason ? `- ${trip.blockReason}` : ''}</div>
                                                    }
                                                </div>
                                                <div
                                                    className={trip.isBlocked ? "btn btn-sm btn-warning float-end" : "btn btn-sm btn-dark float-end"}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (trip.isBlocked) {
                                                            handleUnblockTrip(trip);
                                                        }
                                                        else {
                                                            handleTripAction(trip);
                                                        }
                                                    }}
                                                >
                                                    {trip.isBlocked ? 'Unblock' : 'Select'}
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'selectOrder' &&
                        <>
                            {isTripLoading &&
                                <Loader />
                            }
                            {!isTripLoading &&
                                <>
                                    <div className='container' style={{ position: "fixed", top: "70px", zIndex: 1000 }}>
                                        <div className='row mt-2 justify-content-center' style={{ marginRight: "1rem" }}>
                                            <div className='col-10 p-0'>
                                                <input type="text" className="form-control w-100" placeholder="Scan barcode"
                                                    value={packageNumber}
                                                    ref={barcodeRefRef}
                                                    onChange={(e) => setPackageNumber(e.target.value)}
                                                    onKeyPress={e => { if (e.key === 'Enter') { handlePackage() } }}
                                                    autoFocus />
                                            </div>
                                            <div className='col-2 p-0'>
                                                <div className='btn btn-sm btn-light w-100 h-100' style={{ textAlign: "center" }} onClick={() => setScreen('scanBarcode')}>
                                                    <FontAwesomeIcon icon={faBarcode} style={{ marginRight: "10px", verticalAlign: "middle" }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: "70px" }}>
                                        <div className='col-12'>
                                            <div className='page-header bg-dark' style={{ paddingBottom: "10px" }}>
                                                <div className="fw-bold">{trip?.name}</div>
                                                <div>No: {trip?.voucherNumber}</div>
                                                <div><b>{convertKgToTon(trip?.details.reduce((acc, detail) => acc + detail.order.totalWeight, 0))}</b> tons<br /></div>
                                            </div>
                                        </div>
                                    </div>
                                    {(trip && trip.details.length > 0) &&
                                        <div className="row card m-0 mb-2 mt-2 p-2">
                                            <div className="col-12">
                                                <>
                                                    <div>
                                                        <div className="fw-bold">Vehicle Details</div>
                                                    </div>
                                                    {showVehicleDetails === false &&
                                                        <>
                                                            <div>
                                                                <div className="ms-4">
                                                                    <div>Vehicle Number: <b>{trip.vehicleNumber}</b></div>
                                                                    <div>Driver Name: <b>{trip.driverName}</b></div>
                                                                    <div>Driver Number: <b>{trip.driverNumber}</b></div>
                                                                </div>
                                                                <div className="float-end" style={{ marginRight: "1rem" }}>
                                                                    <div className="btn btn-sm btn-dark" onClick={() => setShowVehicleDetails(true)}>Edit</div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </>
                                            </div>
                                            {showVehicleDetails === true &&
                                                <div id="vehicleDetails" className={showVehicleDetails ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby="vehicleDetails">
                                                    <div className="accordion-body p-0">
                                                        <div className="row form p-2">
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">Vehicle Number</label>
                                                                    <input type="text" className="form-control" value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">Driver Name</label>
                                                                    <input type="text" className="form-control" value={driverName} onChange={(e) => setDriverName(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12 col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">Driver Number</label>
                                                                    <input type="text" className="form-control" value={driverNumber} onChange={(e) => setDriverNumber(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row form p-2'>
                                                            <div className="col-12">
                                                                <div className='btn btn-sm btn-dark' onClick={() => cancelVehicleDetailsEdit()}>Skip \ Cancel</div>
                                                                <div className='btn btn-sm btn-success float-end' onClick={() => saveVehicleDetails()} style={{ marginLeft: "10px" }}>Save</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {showVehicleDetails === false &&
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className="accordion" id="tripAccordion">
                                                    {(!trip || trip.details.length == 0) &&
                                                        <div className='alert alert-danger w-100'>No orders are assigned to this trip, Please refresh again once orders are assigned</div>
                                                    }
                                                    {trip && trip.details.map((detail) => (
                                                        <>
                                                            <div className="accordion-item">
                                                                <div className="accordion-header" id={detail.id.toString()}>
                                                                    <div className={detail?.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                                                        <>
                                                                            <div className="w-100">
                                                                                <div># <span className="fw-bold" style={{ color: "red" }}>{detail.order.voucherNumber}</span></div>
                                                                                <div className="float-start">
                                                                                    {detail.order.partyName}<br />
                                                                                    <b>{convertKgToTon(detail.order.totalWeight)}</b> tons<br />
                                                                                    {detail.scannedPackages} of <b>{detail.order.totalPackages}</b> packages scanned
                                                                                    {detail.scannedPackages >= detail.order.totalPackages &&
                                                                                        <FontAwesomeIcon icon={faSquareCheck} color="green" style={{ marginLeft: "10px" }} />
                                                                                    }
                                                                                </div>
                                                                                {detail.order.id != orderId &&
                                                                                    <div className="float-end" style={{ marginRight: "1rem" }}>
                                                                                        <div className="btn btn-sm btn-dark" onClick={() => setOrderId(detail.order.id)}>Select</div>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </>
                                                                    </div>
                                                                </div>
                                                                <div id={"b" + detail.id.toString()} className={detail.order.id === orderId ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"d" + detail.id.toString()}>
                                                                    <div className="accordion-body p-0">
                                                                        <div className="list-group">
                                                                            {detail.products.map((product) => (
                                                                                <>
                                                                                    <div className="list-group-item">
                                                                                        <div className='row'>
                                                                                            <div className="mb-2">
                                                                                                <b>{product.productName}</b>
                                                                                                <span className="ms-2 text-muted float-end">
                                                                                                    <span className="badge bg-success">{product.packages.filter(pack => pack.isScanned).length}</span> / <span className="badge bg-danger">{product.packages.length}</span>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className='row'>
                                                                                            {product.packages.map((pack) => (
                                                                                                <div className='card col-2 col-md-1 mb-1 p-0' key={pack.packageNumber} id={"p_" + pack.packageNumber}>
                                                                                                    <div className="card-body text-center p-1">
                                                                                                        <FontAwesomeIcon icon={pack.isScanned ? faSquareCheck : faCircle} color={pack.isScanned ? "green" : "red"} />
                                                                                                        {/* {pack.packageNumber} */}
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectTrip')}>Back</div>
                                    {totalPackages === scannedPackages &&
                                        <div className="btn btn-success float-end" onClick={() => completeLoading()}>Complete Loading</div>
                                    }
                                </div>
                            </div>
                        </>
                    }
                    {screen === 'scanBarcode' &&
                        <>

                            <div className='row'>
                                <div className='col-12'>
                                    <BarcodeScanner onCapture={(barcodes) => onBarcodeCaptured(barcodes)} onAbort={() => setScreen('selectOrder')} options={{ delay: 1000, formats: ['code_128', 'code_39', 'code_93', 'ean_8', 'ean_13', 'upc_a', 'upc_e'] }} />
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-12'>
                                    <div className="btn btn-sm btn-danger float-start" onClick={() => setScreen('selectOrder')}>Back</div>
                                </div>
                            </div>

                        </>
                    }
                </>
            }
        </div >
    );
};